import { RequestsApi } from '../RequestsApi';

class PaymentApi extends RequestsApi {
    async getPlansList() {
        return await this.request('/payment/plan', 'get');
    }

    async getProductsList() {
        return await this.request('/payment/product', 'get');
    }

    async createOfferForUserByPlan(planId) {
        return await this.request(`/payment/plan/${planId}/offer`, 'post');
    }

    async getPaymentsHistory(page) {
        return await this.request(`/payment/history?page=${page}`, 'get');
    }

    async createPaymentTrial(params) {
        // add session devise id here
        return await this.request(`/payment/token/trial`, 'post', params);
    }

    async createPaymentPlan(id, data) {
        // add session devise id here
        return await this.request(`/payment/token/subscription/${id}`, 'post', data);
    }

    async createPaymentProduct(id, data) {
        return await this.request(`/payment/token/product/${id}`, 'post', data);
    }

    async createGooglePayToken(data) {
        return await this.request(`/payment/google-pay/token`, 'post', data);
    }

    async cancelSubscription() {
        return await this.request(`/payment/subscription/cancel`, 'post');
    }
    async validationAppleSession(data) {
        return await this.request(`/payment/apple-pay/validate`, 'post', data);
    }
    async createApplePayToken(data) {
        return await this.request(`/payment/apple-pay/token`, 'post', data);
    }
}

export default new PaymentApi();
